import React, { useEffect, useState } from 'react';
import "../styles/AdminUserProfile.css";
import { FolderDown, Ban, Award, BookOpen, ClipboardList, CheckCircle2, XCircle } from 'lucide-react';
import axiosClient from '../api/axiosClient';
import AdminGraph from "../Components/AdminGraph";
import { formatTest, sortNewestFirst } from "../script/formatTestName";



const TestLabel = ({ name }) => {
  const { title, subtitle, badge } = formatTest(name);
  return (
    <span className="test-label" title={name}>
      <span className="test-label-top">
        <span className="test-label-title">{title}</span>
        {badge && (
          <span className={`test-badge test-badge-${badge.toLowerCase()}`}>
            {badge}
          </span>
        )}
      </span>
      {subtitle && <span className="test-label-sub">{subtitle}</span>}
    </span>
  );
};

const ProfilePage = ({ selectedUser }) => {

  const [userdata, setuserdata] = useState({
    name: 0,
    userId: 0,
    emailId: 0,
    lastLoginTime: 0,
    selectedCourses: [],
    problemSolverPercent: 0,
    problemSolverDate: "",
    interviewAcePercent: 0,
    interviewAceDate: "",
    masterOfProblemSolverPercent: 0,
    masterOfProblemSolverDate: "",
    interviewMaestroPercent: 0,
    interviewMaestroDate: "",
    problemSolvingVirtuosoPercent: 0,
    problemSolvingVirtuosoDate: "",
    challengesChampionPercent: 0,
    challengesChampionDate: "",
    moduleTestsPassed: 0,
    moduleTestsFailed: 0,
    totalAttempts: 0
  });

  const [isBlocked, setIsBlocked] = useState(false);
  const [Reports, setReports] = useState([]);
  const [SelectedtestName, setSelectedtestName] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const Fetchuser = async () => {
    try {
      const token = localStorage.getItem("admintoken");

      const res = await axiosClient.get(
        `/auth/admin/user-detail/userIdAndModuleName`,
        {
          params: { userId: selectedUser },
          headers: { Authorization: `${token}` },
        }
      );

      const data = res.data;

      setIsBlocked(data.blockedUser);

      setuserdata({
        name: data.name,
        userId: data.userId,
        emailId: data.emailId,
        lastLoginTime: data.lastLoginTime,
        selectedCourses: data.selectedCourses,
        problemSolverPercent: data.classBadges.problemSolver.percentage,
        problemSolverDate: data.classBadges.problemSolver.earnedDate,
        interviewAcePercent: data.classBadges.interviewAce.percentage,
        interviewAceDate: data.classBadges.interviewAce.earnedDate,
        masterOfProblemSolverPercent: data.classBadges.masterOfProblemSolver.percentage,
        masterOfProblemSolverDate: data.classBadges.masterOfProblemSolver.earnedDate,
        interviewMaestroPercent: data.classBadges.interviewMaestro.percentage,
        interviewMaestroDate: data.classBadges.interviewMaestro.earnedDate,
        problemSolvingVirtuosoPercent: data.classBadges.problemSolvingVirtuoso.percentage,
        problemSolvingVirtuosoDate: data.classBadges.problemSolvingVirtuoso.earnedDate,
        challengesChampionPercent: data.classBadges.challengesChampion.percentage,
        challengesChampionDate: data.classBadges.challengesChampion.earnedDate,
        totalTestsPassed: data.testSummary.totalPassedCount,
        totalTestsFailed: data.testSummary.totalFailedCount,
        totalAttempts: data.testSummary.totalTestCount,
      });

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Fetchuser();
  }, [selectedUser]);

  const getreport = async () => {
  try {
    const token = localStorage.getItem("admintoken");

    const res = await axiosClient.get(
      `/auth/admin/user-detail/userIdAndModuleName`,
      {
        params: { userId: selectedUser },
        headers: { Authorization: `${token}` },
      }
    );

    const data = res.data;

    const names = Array.isArray(data?.testSummary?.listOfTestNames)
      ? data.testSummary.listOfTestNames
      : [];

    const filteredTests = names.filter(
      (test) => typeof test === "string" && !test.startsWith("CUSTOM_")
    );

    setReports(sortNewestFirst(filteredTests));
  } catch (error) {
    console.log(error);
  }
};

  const handleuser = async () => {
    try {
      const userId = selectedUser;
      const token = localStorage.getItem("admintoken");

      if (isBlocked) {
        await axiosClient.post(`/auth/admin/${userId}/unblockUser`, {}, {
          headers: { Authorization: ` ${token}` },
        });
      } else {
        await axiosClient.post(`/auth/admin/${userId}/blockUser`, {}, {
          headers: { Authorization: `${token}` },
        });
      }

      await Fetchuser();

    } catch (error) {
      console.error(error);
    }
  };

  const Downloadapi = async (item) => {
    try {
      const token = localStorage.getItem("admintoken");

      const res = await axiosClient.get(`/auth/admin/download-report`, {
        params: {
          userId: selectedUser,
          testName: item,
        },
        headers: { Authorization: `${token}` },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${item}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.log(error);
    }
  };

  const initials = (userdata.name || "")
    .toString()
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";

  const passRate = userdata.totalAttempts
    ? ((userdata.totalTestsPassed / userdata.totalAttempts) * 100).toFixed(1)
    : 0;
  const failRate = userdata.totalAttempts
    ? ((userdata.totalTestsFailed / userdata.totalAttempts) * 100).toFixed(1)
    : 0;

  const badges = [
    { name: "Problem Solver", percent: userdata.problemSolverPercent, date: userdata.problemSolverDate },
    { name: "Interview Ace", percent: userdata.interviewAcePercent, date: userdata.interviewAceDate },
    { name: "Problem Architect", percent: userdata.masterOfProblemSolverPercent, date: userdata.masterOfProblemSolverDate },
    { name: "Interview Maestro", percent: userdata.interviewMaestroPercent, date: userdata.interviewMaestroDate },
    { name: "Algorithm Virtuoso", percent: userdata.problemSolvingVirtuosoPercent, date: userdata.problemSolvingVirtuosoDate },
    { name: "Mission Maestro", percent: userdata.challengesChampionPercent, date: userdata.challengesChampionDate },
  ];

  return (
    <div className="aup-page">

      {/* ---------- top row: profile / reports / actions ---------- */}
      <div className="aup-top-grid">

        <div className="aup-card aup-card--profile">
          <div className="aup-profile-head">
            <div className="aup-avatar">{initials}</div>
            <div>
              <p className="aup-profile-name">{userdata.name}</p>
              <p className="aup-profile-id">ID · {userdata.userId}</p>
            </div>
          </div>

          <ul className="aup-info-list">
            <li className="aup-info-row">
              <span className="aup-info-label">Email</span>
              <span className="aup-info-value">{userdata.emailId}</span>
            </li>
            <li className="aup-info-row">
              <span className="aup-info-label">Last active</span>
              <span className="aup-status-pill">
                <span className="aup-status-dot" />
                {userdata.lastLoginTime}
              </span>
            </li>
            <li className="aup-info-row">
              <span className="aup-info-label">Course</span>
              <span className="aup-info-value aup-info-value--accent">
                {userdata.selectedCourses?.length > 0
                  ? userdata.selectedCourses.join(", ")
                  : "No course selected"}
              </span>
            </li>
          </ul>
        </div>

        <div className="aup-card aup-card--reports">
          <h2 className="aup-card-title">Review &amp; report</h2>
          <div className="aup-reports">
            <div className="aup-report-trigger">
              <span>Performance report</span>
              <button
                type="button"
                aria-label="View performance reports"
                onClick={() => { setShowPopup(true); getreport(); }}
              >
                <FolderDown size={18} />
              </button>
            </div>

            {showPopup && (
              <div className="aup-modal-overlay" onClick={() => setShowPopup(false)}>
                <div className="aup-modal" onClick={(e) => e.stopPropagation()}>
                  <div className="aup-modal-header">
                    <h2 className="aup-modal-title">Test reports</h2>
                    <button className="aup-modal-close" onClick={() => setShowPopup(false)}>✕</button>
                  </div>
                  <div className="aup-report-list">
                    {Reports.length > 0 ? (
                     Reports.map((item, index) => (
  <div className="aup-report-item" key={index}>
    <div className="aup-report-name">
      <TestLabel name={item} />
    </div>
    <button onClick={() => Downloadapi(item)} className="aup-btn aup-btn--download">
      Download
    </button>
  </div>
))
                    ) : (
                      <p className="aup-empty">No reports available</p>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="aup-card aup-card--block">
          <h2 className="aup-card-title">User action</h2>
          <div className="aup-actions">
            <button onClick={handleuser} className="aup-btn--outline aup-btn--danger">
              <Ban size={15} />
              {isBlocked ? "Unblock user" : "Block user"}
            </button>
            {/* <button className="aup-btn--outline aup-btn--danger">
              <Ban size={15} />
              Delete user
            </button> */}
          </div>
        </div>

      </div>

      {/* ---------- stat row ---------- */}
      <div className="aup-stats-grid">
        <div className="aup-stat-card">
          <div className="aup-stat-icon aup-stat-icon--courses"><BookOpen size={20} /></div>
          <div className="aup-stat-body">
            <span className="aup-stat-value">{userdata.selectedCourses.length}</span>
            <span className="aup-stat-label">Enrolled courses</span>
          </div>
        </div>

        <div className="aup-stat-card">
          <div className="aup-stat-icon aup-stat-icon--tests"><ClipboardList size={20} /></div>
          <div className="aup-stat-body">
            <span className="aup-stat-value">{userdata.totalAttempts}</span>
            <span className="aup-stat-label">Total tests given</span>
          </div>
        </div>

        <div className="aup-stat-card">
          <div className="aup-stat-icon aup-stat-icon--pass"><CheckCircle2 size={20} /></div>
          <div className="aup-stat-body">
            <span className="aup-stat-value">{userdata.totalTestsPassed}</span>
            <span className="aup-stat-label">Tests passed</span>
            <span className="aup-stat-sub aup-stat-sub--pass">{passRate}% pass rate</span>
          </div>
        </div>

        <div className="aup-stat-card">
          <div className="aup-stat-icon aup-stat-icon--fail"><XCircle size={20} /></div>
          <div className="aup-stat-body">
            <span className="aup-stat-value">{userdata.totalTestsFailed}</span>
            <span className="aup-stat-label">Tests failed</span>
            <span className="aup-stat-sub aup-stat-sub--fail">{failRate}% fail rate</span>
          </div>
        </div>
      </div>

      {/* ---------- badges + graph ---------- */}
      <div className="aup-bottom-grid">

        <div className="aup-badges">
          <h2 className="aup-card-title">Badges earned</h2>
          {badges.map((b) => (
            <div className="aup-badge-row" key={b.name}>
              <div className="aup-badge-icon"><Award size={18} /></div>
              <div className="aup-badge-main">
                <div className="aup-badge-top">
                  <span className="aup-badge-name">{b.name}</span>
                  <span className="aup-badge-score">{b.percent}%</span>
                </div>
                <div className="aup-badge-track">
                  <div className="aup-badge-fill" style={{ width: `${b.percent}%` }} />
                </div>
                <div className="aup-badge-date">{b.date}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="aup-graph">
          <AdminGraph userid={selectedUser} moduleName={userdata.selectedCourses} />
        </div>

      </div>

    </div>
  );
};

export default ProfilePage;